'use strict'

/**
 *
 * @name: nnSplashscreenAdModal
 *
 */

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import DirectiveTemplate from './nn-splashscreen-ad-modal.directive.html'
import './nn-splashscreen-ad-modal.directive.scss'

function NnSplashscreenAdModalDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: DirectiveTemplate,
    controller: DirectiveController
  }
}

function DirectiveController ($scope, $element, apiSplashscreenAdService, $sce) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */


  $scope.src = {
    img: '',
    video: '',
    videoPoster: ''
  }
  $scope.target = ''
  $scope.isLoading = true
  $scope.$sce = $sce
  $scope.isAnchorVisible = false
  $scope.trackingPixel = ''


  /*
   *
   * @PUBLIC
   *
   */


  $scope.handleClose = () => {
    _terminate()
  }

  $scope.playVideo = () => {
    const video = document.getElementById('nn-splashscreen-ad-modal__video')
    video.play()
    $scope.isAnchorVisible = true
  }


  /*
   *
   * @PRIVATE
   *
   */

  function _terminate () {
    enableBodyScroll($element[0]);
    $scope.$destroy();
    $element.find('*').remove();
    $element.remove();
  }

  function _getAdvert () {
    apiSplashscreenAdService.get()
      .then(res => {
        const { data } = res

        if (!data) return _terminate()

        if (data.videoUrl) {
          $scope.src.video = data.videoUrl
          $scope.src.videoPoster = data.posterUrl || ''

        } else if (data.lowResImageUrl) {
          $scope.src.img = data.lowResImageUrl
          $scope.isAnchorVisible = true
        }

        $scope.target = data.targetUrl || ''
        $scope.trackingPixel = data.trackingPixel || ''

        disableBodyScroll($element[0]);
      })
      .catch(() => {
        _terminate()
      })
      .finally(() => {
        $scope.isLoading = false
      })
  }

  /*
   *
   * @INIT
   *
   */

  _getAdvert()
}

export default NnSplashscreenAdModalDirective



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-splashscreen-ad-modal/nn-splashscreen-ad-modal.directive.js